import { render } from "./EditSort.vue?vue&type=template&id=05841329"
import script from "./EditSort.vue?vue&type=script&lang=js"
export * from "./EditSort.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__